// import dependencies
import types from "../constants";

export const tasksSetGroup = payload => ({
    "type": types.TASK_SET_GROUP,
    payload
});